var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMapsCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500488,
    y: 0.560059,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5005 8.61954V15.5975M15.5005 10.5226V17.5006M15.9198 20.4596L19.9823 18.3979C20.2999 18.2368 20.5005 17.9073 20.5005 17.5468V6.98737C20.5005 6.28001 19.7671 5.81994 19.1437 6.13628L15.9198 7.77241C15.6558 7.90635 15.3452 7.90635 15.0812 7.77241L10.9198 5.66052C10.6558 5.52657 10.3452 5.52657 10.0812 5.66052L6.01873 7.72218C5.70112 7.88337 5.50049 8.21285 5.50049 8.57327V19.1327C5.50049 19.8401 6.23391 20.3002 6.85725 19.9838L10.0812 18.3477C10.3452 18.2138 10.6558 18.2138 10.9198 18.3477L15.0812 20.4596C15.3452 20.5935 15.6558 20.5935 15.9198 20.4596Z",
    stroke: "#2A9DF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMapsCircle);
export default __webpack_public_path__ + "static/media/ic-maps-circle.1c21d54f94e24319025ec45bd498e745.svg";
export { ForwardRef as ReactComponent };